<div class="row">
  <nav class="navbar navbar-fixed-top" role="navigation" style="margin-bottom: 0">
    <div class="navbar-header">
      <!-- <a class="minimalize-styl-2 btn btn-primary " (click)="toggleNavigation()"> <i class="fa fa-bars"></i> </a> -->
      <!--
      <form role="search" class="navbar-form-custom" method="post" action="#">
        <div class="mb-3">
          <input type="text" placeholder="Search for something..." class="form-control" name="top-search" id="top-search">
        </div>
      </form>
      -->
      <div class="page-title" (click)="toggleNavigation()">
        <h1>{{ app.appInfo.title }}</h1>
      </div>
      @if (app.appInfo.versionWarning) {
        <div class="navbar-warning">
          <i class="fa fa-warning ms-2" title="{{app.appInfo.versionWarning}}"></i>
        </div>
      }
    </div>
    <ul class="nav navbar-top-links navbar-right d-none d-sm-block">
      <li style="margin-right: 15px;">
        <a [routerLink]="''" style="padding: 0;"> <img src="./assets/images/Ark-Logo.png" style="width: 100%;" /> </a>
      </li>
    </ul>
  </nav>
</div>
